module.exports = __webpack_public_path__ + "img/train_empty2.b3ba26f8.png";